import { action, makeObservable, observable } from "mobx";
import OfferService from "../../services/OfferService";
import { Offer, OfferOrderBy, OfferStatus } from "./types";
import authStore from "../AuthStore";

class OfferStore {
  @observable lawyerOffers: Offer[] = [];
  @observable userOffers: Offer[] = [];

  offerService = new OfferService();

  constructor() {
    makeObservable(this);
  }

  @action fetchLawyerOffers() {
    this.offerService
      .fetchLawyerOffers(authStore.user?.id)
      .then((offers) => (this.lawyerOffers = [...offers]));
  }

  @action fetchUserOffers() {
    this.offerService
      .fetchUserOffers(authStore.user?.id)
      .then((offers) => (this.userOffers = offers));
  }

  searchOffers(
    keyword: string,
    orderBy?: OfferOrderBy,
    size?: number,
    page?: number,
    status?: OfferStatus
  ): Promise<{ offers: Offer[]; count: number }> {
    return this.offerService.searchOffers(
      keyword,
      orderBy || OfferOrderBy.CREATE_DATE_DESC,
      size || 100,
      page || 0,
      status || OfferStatus.PENDING
    );
  }

  fetchOffer(offerId: string): Promise<Offer> {
    return this.offerService.fetchOffer(offerId);
  }

  submitOffer(summary: string, caseId: string, userId: string): Promise<Offer> {
    return this.offerService.submitOffer({
      summary,
      caseId,
      userId,
    });
  }

  updateOffer(offerId: string, summary: string): Promise<Offer> {
    return this.offerService.updateOffer({
      id: offerId,
      summary,
    });
  }

  updateOfferStatus(
    offer: Offer,
    status: OfferStatus,
    reason?: string
  ): Promise<Offer> {
    return this.offerService.updateOffer({
      ...offer,
      status,
      reason,
    });
  }

  @action replyOffer(id: string, status: OfferStatus): Promise<Offer> {
    return this.offerService.replyOffer(id, status).then((result) => {
      this.userOffers = this.userOffers.map((offer) =>
        id === offer.id ? result : offer
      );
      return result;
    });
  }

  @action abortOffer(id: string) {
    return this.offerService.abortOffer(id).then((result) => {
      this.userOffers = this.userOffers.map((offer) =>
        id === offer.id ? result : offer
      );
      return result;
    });
  }
}

export default OfferStore;
